 <div class="main">

    <div class="frm" dir="rtl">

        <h2 style="text-align: center;">{{had}}</h2>

        <form #f="ngForm" (ngSubmit)="submit()">
            <div class="row">
                <div class="btnSave">
                    <button class="btn btn-primary" [disabled]="f.invalid || isRequesting">Save</button>
                </div>
            </div>

            <div class="row frm2" style="background-color:#f4f4f4">
                <div class="row">

                    <div class="col-lg-6 pull-right">
                        <div class="row">

                            <div class="col-lg-6 pull-right">
                                <div class="form-group">
                                    <label for="title" style="font-weight:bold">המכונה בפי כל</label>
                                    <input required id="title" name="title" class="form-control" [(ngModel)]="tz.title" />
                                </div>
                            </div>

                            <div class="col-lg-6 pull-right">
                                <div class="form-group">
                                    <label for="subTitle" style="font-weight:bold">שם משפחה</label>
                                    <input id="subTitle" name="subTitle" class="form-control" [(ngModel)]="tz.subTitle" />
                                </div>
                            </div>




                            <div class="col-lg-3 pull-right">
                                <div class="form-group">
                                    <label for="tzadikTitle" style="font-weight:bold">תואר</label>
                                    <input id="tzadikTitle" name="tzadikTitle" class="form-control" [(ngModel)]="tz.tzadikTitle" />
                                </div>
                            </div>

                            <div class="col-lg-6 pull-right">
                                <div class="form-group">
                                    <label for="tzadikFirstName" style="font-weight:bold">שם</label>
                                    <input id="tzadikFirstName" name="tzadikFirstName" class="form-control" [(ngModel)]="tz.tzadikFirstName" />
                                </div>
                            </div>

                            <div class="col-lg-3 pull-right">
                                <div class="form-group">
                                    <label for="tzadikBN" style="font-weight:bold">בן</label>
                                    <input id="tzadikBN" class="form-control" name="tzadikBN" [(ngModel)]="tz.tzadikBN" />
                                </div>
                            </div>





                            <div class="col-lg-3 pull-right">
                                <div class="form-group">
                                    <label for="fathersTitle" style="font-weight:bold">תואר אביו</label>
                                    <input id="fathersTitle" name="fathersTitle" class="form-control" [(ngModel)]="tz.fathersTitle" />
                                </div>
                            </div>

                            <div class="col-lg-6 pull-right">
                                <div class="form-group">
                                    <label for="fatherName" style="font-weight:bold">שם אביו</label>
                                    <input id="fatherName" name="fatherName" class="form-control" [(ngModel)]="tz.fatherName" />
                                </div>
                            </div>

                            <div class="col-lg-3 pull-right">
                                <div class="form-group">
                                    <label for="tzadikEndTitle" style="font-weight:bold">זצ"ל</label>
                                    <input id="tzadikEndTitle" name="tzadikEndTitle" class="form-control" [(ngModel)]="tz.tzadikEndTitle" />
                                </div>
                            </div>





                            <div class="col-lg-4 pull-right">
                                <div class="form-group">
                                    <label for="nlDay" style="font-weight:bold">נולד ביום</label>
                                    <input id="nlDay" name="nlDay" class="form-control" [(ngModel)]="tz.nlDay" />
                                </div>
                            </div>

                            <div class="col-lg-4 pull-right">
                                <div class="form-group">
                                    <label for="nlMonth" style="font-weight:bold">נולד בחודש</label>
                                    <input id="nlMonth" name="nlMonth" class="form-control" [(ngModel)]="tz.nlMonth" />
                                </div>
                            </div>

                            <div class="col-lg-4 pull-right">
                                <div class="form-group">
                                    <label for="nlYear" style="font-weight:bold">נולד בשנת</label>
                                    <input id="nlYear" name="nlYear" class="form-control" [(ngModel)]="tz.nlYear" />
                                </div>
                            </div>





                            <div class="col-lg-4 pull-right">
                                <div class="form-group">
                                    <label for="nfDay" style="font-weight:bold">נפטר ביום</label>
                                    <input id="nfDay" name="nfDay" class="form-control" [(ngModel)]="tz.nfDay" />
                                </div>
                            </div>

                            <div class="col-lg-4 pull-right">
                                <div class="form-group">
                                    <label for="nfMonth" style="font-weight:bold">נפטר בחודש</label>
                                    <input id="nfMonth" name="nfMonth" class="form-control" [(ngModel)]="tz.nfMonth" />
                                </div>
                            </div>

                            <div class="col-lg-4 pull-right">
                                <div class="form-group">
                                    <label for="nfYear" style="font-weight:bold">נפטר בשנת</label>
                                    <input id="nfYear" name="nfYear" class="form-control" [(ngModel)]="tz.nfYear" />
                                </div>
                            </div>





                            <div class="col-lg-6 pull-right">
                                <label for="mkm" style="font-weight:bold">מקום מנוחתו</label>
                                <select required id="mkm" name="mkm" class="form-control" (change)="onMkmChange()" [(ngModel)]="tz.mkmId">
                                    <option *ngFor="let m of mkms" [value]="m.id">{{m.mKmTitle}} - {{m.cityY}}, {{m.stateY}}</option>
                                </select>
                            </div>

                            <div dir="ltr" class="col-lg-6 pull-right">
                                <div class="form-group">
                                    <label for="poi" style="font-weight:bold">Poi</label>
                                    <input id="poi" name="poi" class="form-control" [(ngModel)]="tz.mkm.poi" (change)="onPoiChange()" />
                                </div>
                            </div>
                            </div>
                            <div class="col-lg-6 pull-right">
                                 <div class="form-group">
                                    <label for="toldes" style="font-weight:bold">תולדות</label>
                                    <textarea id="toldes" name="toldes" cols="55" rows="5" class="form-control" [(ngModel)]="tz.toldes"></textarea>
                                </div>
                            </div>

                           <div class="col-lg-6 pull-right pe-lg-3">
                                <div class="form-group">
                                    <label for="mchs" style="font-weight:bold">ספרים שחיבר</label>
                                    <textarea id="mchs" name="mchs" cols="55" rows="5" class="form-control" [(ngModel)]="tz.mchs"></textarea>
                                </div>
                            </div>
                    </div>
                     <div class="col-lg-6 pull-right">
                         <div class="form-group">
                            <label for="tfilis" style="font-weight:bold">תפילות וענינים</label>
                            <textarea id="tfilis" name="tfilis" cols="55" rows="5" class="form-control" [(ngModel)]="tz.tfilis"></textarea>
                        </div>
                        <!-- <div>Upload Pic. Comming Soon</div> -->
                        <div class="mb-3">
                            <label for="fileUpload" class="form-label">Select
                                Image</label>
                            <input type="file" class="form-control mb-3" id="uploadImage" (change)="handleOnChange($event)" />

                            <button type="button" (click)="addImageIntoTzadikim()" class="btn btn-primary">
                                Add Image
                            </button>

                        </div>
                        <div class="mb-3" >
                            <div *ngIf="tz?.images?.length > 0; else noImages">
                                <div class="row">
                                    <div *ngFor="let img of tz.images" class="col-3 mt-3 image-box">
                                        <a (click)="onDelete(img.id)" title="Delete Image" style="cursor: pointer">
                                            <i class="fa fa-remove"></i>
                                          </a>
                                        <img [src]="'data:image/jpeg;base64,' + img.imageData" alt="">
                                    </div>
                                </div>
                            </div> 
                            <ng-template #noImages>
                                <div>No Image Found</div>
                            </ng-template>
                        </div> 
                    </div> 
                </div>
                <div class="row">
                    <div class="col-lg-4 pull-right">
                        <div *ngIf="errors" class="alert alert-danger" role="alert" dir="ltr">
                            <strong>Oops!</strong> {{errors}}
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
</div> 